import { Card, makeStyles, SkeletonItem } from "@fluentui/react-components";
import styled from "styled-components";

import { Flex } from "components/styled";
const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },

  skeleton: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  fullWidth: {
    width: "100%",
  },
  cardImage: {
    padding: "10px 10px 0px 10px",
    boxSizing: "border-box",
  },

  cardBody: {
    padding: "10px",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  cardIcon: {
    width: "50px",
  },
  cardTab: {
    width: "100px",
  },
});

type Props = {
  cardWithImage?: boolean;
};

export function CardItemSkeleton({ cardWithImage }: Props) {
  const styles = useStyles();

  if (cardWithImage) {
    return (
      <StyledCard $withImage={cardWithImage}>
        <Flex direction="column" $gap={"0px"} width={"100%"} className={styles.cardImage}>
          <SkeletonItem size={72} shape="square" className={styles.fullWidth} />
          <SkeletonItem size={72} shape="square" className={styles.fullWidth} />
          <SkeletonItem size={72} shape="square" className={styles.fullWidth} />
        </Flex>
        <div className={styles.cardBody}>
          <SkeletonItem size={20} shape="square" className={styles.fullWidth} />
          <SkeletonItem size={20} shape="square" className={styles.fullWidth} />
          <Flex $justify="space-between">
            <SkeletonItem size={20} shape="square" className={styles.cardTab} />
            <SkeletonItem size={20} shape="square" className={styles.cardTab} />
          </Flex>
        </div>
        <SkeletonItem size={40} shape="square" className={styles.fullWidth} />
      </StyledCard>
    );
  }

  return (
    <StyledCard>
      <div
        className={styles.cardBody}
        style={{
          gap: "20px",
        }}
      >
        <Flex $justify="space-between">
          <Flex $gap={"10px"}>
            <SkeletonItem size={32} shape="square" className={styles.cardIcon} />
            <SkeletonItem size={32} shape="square" className={styles.cardTab} />
          </Flex>
          <SkeletonItem size={32} shape="square" className={styles.cardTab} />
        </Flex>
        <SkeletonItem size={24} shape="square" className={styles.fullWidth} />
        <SkeletonItem size={24} shape="square" className={styles.fullWidth} />
        <Flex $justify="space-between">
          <SkeletonItem size={24} shape="square" className={styles.cardTab} />
          <SkeletonItem size={24} shape="square" className={styles.cardTab} />
        </Flex>
      </div>
    </StyledCard>
  );
}

export default CardItemSkeleton;

const StyledCard = styled(Card)<{ $withImage?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  padding: 0 !important;
  height: ${(props) => (props.$withImage ? "333px" : "189px")};
  > div {
    width: 100%;
  }
`;
//333 189
